<template>
    <div class="threads">
        <div class="section-title">Сохранённые ветки</div>
        <div ref="listEl" class="threads-list" @scroll="onScroll">
            <div
                v-for="thread in threads"
                :key="thread.id"
                class="thread-row"
                :class="{ 'thread-row--active': thread.id === activeThreadId }"
            >
                <button
                    type="button"
                    class="thread"
                    @click="$emit('select', thread)"
                >
                    <span class="thread-title">{{ thread.title }}</span>
                    <span class="thread-time">{{ thread.timeLabel }}</span>
                </button>
                <button
                    type="button"
                    class="thread-delete"
                    aria-label="Удалить ветку"
                    @click.stop="$emit('delete', thread)"
                >
                    <ChatIcon name="x" :size="12" color="currentColor" />
                </button>
            </div>

            <div v-if="loading" class="threads-foot">Загружаю…</div>
            <div v-else-if="hasMore" class="threads-foot threads-foot--hint">Прокрутите вниз — подгрузим ещё</div>
            <div v-else-if="threads.length && total > threads.length" class="threads-foot threads-foot--hint">
                Показано {{ threads.length }} из {{ total }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import ChatIcon from '@/components/chat/icons/ChatIcon.vue'

const props = defineProps({
    threads: { type: Array, required: true },
    activeThreadId: { type: String, default: null },
    hasMore: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
})

const emit = defineEmits(['select', 'delete', 'load-more'])

const listEl = ref(null)

function onScroll() {
    const el = listEl.value
    if (!el || !props.hasMore || props.loading) return
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight
    if (distance < 72) {
        emit('load-more')
    }
}
</script>

<style scoped>
.threads {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.section-title {
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #888888;
    padding: 0 8px 6px;
    flex-shrink: 0;
}

.threads-list {
    display: flex;
    flex-direction: column;
    gap: 1px;
    max-height: min(360px, 42vh);
    overflow-y: auto;
    overscroll-behavior: contain;
}

.thread-row {
    display: flex;
    align-items: stretch;
    border-radius: 0 6px 6px 0;
    border-left: 2px solid transparent;
    flex-shrink: 0;
}

.thread-row:hover {
    background: #e7e7e7;
}

.thread-row:hover .thread-delete {
    opacity: 1;
}

.thread-row--active {
    background: #e7e7e7;
    border-left-color: #23282C;
}

.thread {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    padding: 8px 4px 8px 12px;
    border: 0;
    background: transparent;
    font-family: inherit;
    text-align: left;
    cursor: pointer;
}

.thread-delete {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    margin-right: 4px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #888888;
    cursor: pointer;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.12s ease, color 0.12s ease, background-color 0.12s ease;
}

.thread-delete:hover {
    color: #E30613;
    background: rgba(227, 6, 19, 0.08);
}

.thread-row--active .thread-delete {
    opacity: 1;
}

.thread-title {
    font-size: 12.5px;
    font-weight: 500;
    color: #23282C;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.thread-time {
    font-size: 10.5px;
    color: #888888;
    margin-top: 1px;
}

.threads-foot {
    padding: 10px 12px;
    font-size: 11px;
    color: #888888;
    text-align: center;
}

.threads-foot--hint {
    color: #A8A69E;
}
</style>
